import { render, staticRenderFns } from "./RemediationForm.vue?vue&type=template&id=9f85b04e&scoped=true"
import script from "./RemediationForm.vue?vue&type=script&lang=js"
export * from "./RemediationForm.vue?vue&type=script&lang=js"
import style0 from "./RemediationForm.vue?vue&type=style&index=0&id=9f85b04e&prod&scoped=true&lang=css"
import style1 from "./RemediationForm.vue?vue&type=style&index=1&id=9f85b04e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f85b04e",
  null
  
)

export default component.exports